import { forwardRef } from 'react'
import { UseFormFieldProps, useFormField, FormField } from './FormField'
import { InputProps as RootProps } from '@/ui/Input'
import { Input as Root } from '@/ui/Input'

interface Props extends UseFormFieldProps, RootProps {
    // UseFormFieldProps requires 'name', so we override.
    // This also allows us to extend UseFormFieldProps and
    // RootProps at the same time.
    name: string
    warningText?: string
}

export const Input = forwardRef<HTMLInputElement, Props>((props, ref) => {
    const { formFieldProps, childProps } = useFormField(props)

    return (
        <FormField {...formFieldProps}>
            <Root {...childProps} ref={ref} />
        </FormField>
    )
})
